import { BottomSheetModalProvider } from '@gorhom/bottom-sheet';
import { RefreshControl, ScrollView } from 'react-native';

import { Box } from '@squire/ui';

import { MaxWidthWrapper } from '../MaxWidthWrapper';
import { styles } from './styles';
import type { PageProps } from './types';

const Page = ({
  scrollable = false,
  header,
  headerFullWidth = false,
  edges = ['top', 'bottom', 'left', 'right'],
  // App-wide default — screens inherit this rather than overriding it.
  backgroundColor = 'backgroundPrimary',
  refreshControl,
  children,
  style,
  contentContainerStyle,
  paddingHorizontal,
  padding,
  paddingVertical,
  testID,
  ...props
}: PageProps) => {
  // A full-bleed header escapes the centred content column and spans the
  // viewport. On a wide screen that puts the leading control — the menu button —
  // at the left edge, next to the drawer it opens, rather than stranded in the
  // middle of the page. Below the column's breakpoint the two are the same
  // width, so nothing moves.
  const content = (
    <MaxWidthWrapper>
      <Box style={styles.content}>
        {!headerFullWidth && header}
        <Box
          flex
          style={style}
          padding={padding}
          paddingVertical={paddingVertical}
          paddingHorizontal={paddingHorizontal}
        >
          {children}
        </Box>
      </Box>
    </MaxWidthWrapper>
  );

  return (
    <Box
      {...props}
      flex
      testID={testID}
      style={[
        styles.background(backgroundColor),
        styles.container(edges),
        contentContainerStyle,
      ]}
    >
      <BottomSheetModalProvider>
        {headerFullWidth && (
          <Box
            // @ts-expect-error - a Unistyles breakpoint object doesn't satisfy
            // ViewStyle's types but resolves correctly at runtime, the same as
            // BottomSheet's maxWidthWrapper.
            style={styles.fullWidthHeader}
          >
            {header}
          </Box>
        )}
        {scrollable ? (
          <ScrollView
            bounces={false}
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
            refreshControl={
              refreshControl ? (
                <RefreshControl {...refreshControl} />
              ) : undefined
            }
          >
            {content}
          </ScrollView>
        ) : (
          content
        )}
      </BottomSheetModalProvider>
    </Box>
  );
};

Page.displayName = 'Page';
export { Page };
